import { createRoot } from 'react-dom/client'
import './aws-config' // Import AWS Amplify configuration
import './index.css'
import App from './App.tsx'
import { initGtm } from '@/analytics/gtm'

initGtm()

createRoot(document.getElementById('root')!).render(
  
    <App />
  ,
)
